import type { BidViewModel, RouteFullViewModel } from "api";
import { bidKeyFeaturesReviewStagesEnum } from "helpers/enums/bidKeyFeaturesReviewStages";

export const BidKeyFeaturesReviewStage = bidKeyFeaturesReviewStagesEnum;
export type BidKeyFeaturesReviewStage =
    (typeof bidKeyFeaturesReviewStagesEnum)[keyof typeof bidKeyFeaturesReviewStagesEnum];

const BID_KEY_FEATURES_REVIEW_STAGE_VALUES = Object.values(BidKeyFeaturesReviewStage);

export type BidKeyFeaturesReviewStageValue = BidKeyFeaturesReviewStage | string;

export type BidKeyFeaturesReviewModel = {
    bidId: number;
    userId?: number;
    stage: BidKeyFeaturesReviewStageValue;
};

export const normalizeBidKeyFeaturesReviewStage = (stage?: BidKeyFeaturesReviewStageValue | null) => {
    if (stage === null || stage === undefined) {
        return BidKeyFeaturesReviewStage.Completed;
    }

    return BID_KEY_FEATURES_REVIEW_STAGE_VALUES.includes(stage as BidKeyFeaturesReviewStage)
        ? (stage as BidKeyFeaturesReviewStage)
        : BidKeyFeaturesReviewStage.Completed;
};

export const isActiveBidKeyFeaturesReview = (review?: BidKeyFeaturesReviewModel | null) =>
    Boolean(review && normalizeBidKeyFeaturesReviewStage(review.stage) !== BidKeyFeaturesReviewStage.Completed);

export type RelayModel = {
    retType?: string | number | null;
    retId?: string | number | null;
    initStatus?: string;
};

export type OrganizationModel = {
    adminId?: number;
    bidKeyFeaturesReview?: BidKeyFeaturesReviewModel;
    documentsPolicy?: string | number | null;
    relay?: RelayModel;
    pinCode?: string;
};

export type ProfileModel = {
    id?: number;
};

export type TourDriverUserModel = {
    firstName?: string;
    lastName?: string;
    patronymic?: string;
    phoneNumber?: string;
};

export type TourBidModel = Pick<BidViewModel, "id" | "bidPoints"> & {
    driver?: {
        user?: TourDriverUserModel;
    };
    route?: RouteFullViewModel;
};

export type DocumentPreviewType = "contract" | "invoice" | "upd" | "act";

export type TourUniversalDocument = {
    id: number;
    type?: string;
    name?: string;
    isGenerating?: boolean;
};

export type TourDocumentsByType = Partial<Record<DocumentPreviewType, TourUniversalDocument>>;

export type UniversalDocumentsResponse =
    | { data?: TourUniversalDocument[] }
    | TourUniversalDocument[]
    | false
    | null
    | undefined;

export type DocumentPreviewState = {
    type: DocumentPreviewType;
    title: string;
    accessUrlLink: string;
};
